export const GET_PARTNERS_START = 'GET_PARTNERS_START';
export const GET_PARTNERS_FAILED = 'GET_PARTNERS_FAILED';
export const GET_PARTNERS_SUCCESS = 'GET_PARTNERS_SUCCESS';
